import FilterParameterDto from "../datasourcemodule/FilterParameterDto";
import DataTableFieldParameterDefinitionDto from "../datasourcemodule/DataTableFieldParameterDefinitionDto";

class PathReportingMappingDto {
    FieldReferenceId: number;
    TransformationLogicId: number;
    TransformationParameters: string;
    DisplayName: string;
    IsSelected: boolean;
    Filters: FilterParameterDto[];
    DeclaredVariables: DataTableFieldParameterDefinitionDto[];

    constructor(
        fieldReferenceId: number,
        transformationLogicId: number,
        transformationParameters: string,
        displayName: string,
        isSelected: boolean = true,
        filters: FilterParameterDto[],
        declaredVariables: DataTableFieldParameterDefinitionDto[] = []
    ) {
        this.FieldReferenceId = fieldReferenceId;
        this.TransformationLogicId = transformationLogicId;
        this.TransformationParameters = transformationParameters;
        this.DisplayName = displayName;
        this.IsSelected = isSelected;
        this.Filters = filters;
        this.DeclaredVariables = declaredVariables;
    }
}

export default PathReportingMappingDto;
